import { useSelector } from "react-redux";
import RecordEditor from "../../../../shared/ui/common/RecordEditor";
import { editWishList } from "../../api/wish-list";
const fields = [{ name: "userId", label: "شناسه کاربر", numeric: true },
  { name: "advertisementId", label: "شناسه آگهی", numeric: true }];
export default function WishListEditor(props) {
  const { token } = useSelector((state) => state.user);
  return <RecordEditor {...props} title="ویرایش علاقه‌مندی" fields={fields}
    save={(values) => editWishList({ id: props.data.id, ...values }, token)} />;
}
